import { atom } from 'jotai'

/**
 * まとめて配車実施中を表すアトム
 */
export const isMultipleDispatchingAtom = atom(false)

isMultipleDispatchingAtom.debugLabel = 'isMultipleDispatchingAtom'
